import React from 'react'
import styles from '../../_css/Simulation.module.css'

const Empty = ({ message , type = 'default' }) => {

  if(type == 'progress') {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyStateIcon} aria-hidden title="Loading">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <p className={styles.emptyStateMessage}>{message}</p>
      </div>
    )
    }
    return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateIcon} aria-hidden title="Not available">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      </div>
      <p className={styles.emptyStateMessage}>{message}</p>
    </div>
  )
}

export default Empty